/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import * as _ from 'lodash';
import {AngularModalService} from '../common/modal/angular-modal.service';
import {ThirdPartyAudienceUploadModalComponent} from './third-party-audience-upload-modal.component';

@Injectable({providedIn: 'root'})
export class ThirdPartyAudienceModalService {
  constructor(
    private readonly angularModalService: AngularModalService,
    private readonly toastr: ToastrService
  ) {
  }

  openUploadModal(uploadType: 'data' | 'definitions', onUploaded?: () => void): void {
    const modalRef = this.angularModalService.show(ThirdPartyAudienceUploadModalComponent, {
      class: 'modal-lg adnDialog',
      initialState: {
        uploadType
      }
    });

    const modalContent = modalRef.content as ThirdPartyAudienceUploadModalComponent;
    modalContent.onClosed.subscribe((result) => {
      if (!result) {
        return;
      }
      onUploaded?.();
      this.toastr.success(
        'Uploaded ' + _.get(result, ['parameters', 'uploaded'], 0) + ' of ' + _.get(result, ['parameters', 'received'], 0) + ' received rows.',
        'Third-Party Audience Upload'
      );
    });
  }
}
